<script lang="ts" setup>
  import { useBasicSEO } from '~/composables/basicSeo';

  useBasicSEO();
</script>

<template>
  <div class="flex flex-col w-full h-full min-h-[100vh] bg-[#141D27] overflow-hidden">
    <AppHeader />
    <div
      class="mt-[70px] md:mt-[86px] px-[var(--container-padding)] lg:px-0 w-full lg:max-w-[1468px]! mx-auto langin-container"
    >
      <slot />

      <AppFooter />
    </div>
  </div>
</template>
